export default "__VITE_ASSET__DJp_otT6__"